<div class="outer-content-wrapper" [ngClass]="{'full-screen-overlay': isFullScreen}">
  <div class="loading-content-outer">
    <div class="loading-content-inner">
      <div class="grid upload-image-wrapper p-col-12">
        <img class="progress-gif" alt="card" src="../../../../assets/images/progress-gif.gif">
      </div>
    </div>
  </div>
</div>
